import React from "react";
import { createRoot } from "react-dom/client";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import App from "./components/App";

const theme = extendTheme({
  fonts: {
    heading:
      "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, Apple Color Emoji, Segoe UI Emoji",
    body:
      "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, Apple Color Emoji, Segoe UI Emoji",
  },
});

// Disable Turbo before any navigation lifecycle can cache or restore a blank SPA shell.
if (window.Turbo) {
  window.Turbo.session.drive = false;
}

const mountReactApp = () => {
  const el = document.getElementById("react-root");
  if (!el) return;

  if (!el.__reactRoot) {
    el.__reactRoot = createRoot(el);
  }

  el.__reactRoot.render(
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  );
};

document.addEventListener("DOMContentLoaded", mountReactApp);
document.addEventListener("turbo:load", mountReactApp);
window.addEventListener("pageshow", mountReactApp);
